import {
  WorklistFilters,
  type FilterDefinitionType,
  type FilterStateType,
  type WorklistFiltersType,
  type WorklistSurfaceSearchValues,
} from './types';

import { SORTABLE_WORKLIST_COLUMN_MAP, SORT_ORDER } from 'config/constants';
import { WorklistSurface } from '../Worklist/types';
import type { WorklistSurfaceType } from '../Worklist/types';
import type { SortColumn, SortOrder } from 'generated/graphql';

export const DEFAULT_WORKLIST_SORT_COLUMN_ID = 'studyDate';
export const DEFAULT_SORT_COLUMNS: Array<SortColumn> = [
  SORTABLE_WORKLIST_COLUMN_MAP[DEFAULT_WORKLIST_SORT_COLUMN_ID] as SortColumn,
];

export const DEFAULT_SORT_ORDERS: Array<SortOrder> = [SORT_ORDER.ASCENDING as SortOrder];

export const DEFAULT_WORKLIST_SURFACE_SEARCH_VALUES: WorklistSurfaceSearchValues =
  Object.fromEntries(
    Object.values(WorklistSurface).map((surface: WorklistSurfaceType) => [surface, ''])
  );

export const DEFAULT_EMPTY_WORKLIST_SURFACE_FILTERS: {
  [key: string]: FilterStateType;
} = Object.fromEntries(
  Object.values(WorklistSurface).map((surface: WorklistSurfaceType) => [surface, {}])
);

export type FilterConfig = Partial<
  Record<
    WorklistSurfaceType,
    {
      lockedFilters: FilterStateType;
      defaultFilters: FilterDefinitionType;
      hiddenFilters: WorklistFiltersType[];
    }
  >
>;

export const WorklistFilterDateTypes = [
  'submittedAt',
  'submitted_at',
  'submitted_at_before',
  'submitted_at_after',
  'studyDate',
  'study_datetime',
  'study_datetime_before',
  'study_datetime_after',
  'patient_dob',
  'patientDob',
  'patient_dob_before',
  'patient_dob_after',
];

// These filters are invalid for custom worklists because they contain
// patient-specific data that should not be saved as persistent filters, or are
// absolute date fields which should be relative to be suitable for custom
// worklists.
export const INVALID_CUSTOM_WORKLIST_FILTERS: WorklistFiltersType[] = [
  WorklistFilters.AccessionNumber,
  WorklistFilters.Mrn,
  WorklistFilters.PatientName,
  WorklistFilters.PatientDob,
  WorklistFilters.SubmittedAt,
  WorklistFilters.StudyDate,
];
